// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Kg8j","owner-meta-container":"_3PC6E","cover-image-container":"_3L2SI","progress-donate-container":"_1RlLY","owner":"_2Ot8h","crowdfunding-title-link":"_19AN-","title-wrapper":"tuA3h","title":"qquOT","countdown":"_1nBrW","meta":"n1lvr","progress":"_2CErZ","actions":"_20Tva","share-unavailable":"_3I2D5","recurring-donations":"_3o9qU","bottom-right":"_1Qt_b","link":"BpHwL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageHeader/PageHeader.scss
// module id = ./src/components/Page/PageHeader/PageHeader.scss
// module chunks = 5